module.exports = __webpack_public_path__ + "static/media/telos1.a213d4e6.jpg";